var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "func/forwardarrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets-overview-unfolded",
    transform: "translate(-103.000000, -478.000000)",
    fill: "#8B93A7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row/dapp-title",
    transform: "translate(20.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "misc/title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-misc/unfolded",
    transform: "translate(83.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.18410756 7.83504914 10 7.03960968 5 2.16495086 0 7.03960968 0.81589244 7.83504914 5 3.75582977"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.1330617ad04e91ae80c01d27143f5153.svg";
export { ForwardRef as ReactComponent };